import { ProviderCodeEnum } from "utils/enums/ProviderCodeEnum";

export class ErrorCodeGeneralRequestEntity {
  service?: string;
  partner?: string;
  telco?: Array<string>;
  isOnlyStore?: boolean;
  store?: Array<string>;
  staff?: Array<string>;
  timeType?: number;
  classType?: number;
  partnerB2B?: string;
  partnerChainB2C?: string;
  partnerNeci?: string;
  singleUserB2C?: string;
  partnerGuest?: string;
  specificSingleUser?: string;

  isNeci?(providerCode: string) {
    return providerCode === ProviderCodeEnum.neci;
  }

  isSMM?(providerCode: string) {
    return providerCode === ProviderCodeEnum.smm;
  }

  isPartnerB2B?(providerCode: string, type: number) {
    return type === 0 && providerCode === ProviderCodeEnum.b2b;
  }

  isSingleUserB2C?(providerCode: string, type: number) {
    return type === 1 && providerCode === ProviderCodeEnum.mobitopup;
  }

  isPartnerChainB2C?(type: number) {
    return type === 1;
  }

  isPartnerGuest?(providerCode: string, type: number) {
    return type === 2 && providerCode === ProviderCodeEnum.mobitopup;
  }
}
